import { Calculator, Container } from '@/components'

import styles from './Simulation.module.scss'

export const Simulation = () => {
  return (
    <section className={styles.simulation}>
      <Container>
        <div className={styles.simulation__wrapper}>
          <Calculator />
        </div>
      </Container>
    </section>
  )
}
